import { useContext, useEffect } from 'react';
import { MainContext } from '../../context/main.context';
import { useNavigate } from 'react-router-dom';
import { HORNY_BACKGROUND_LOGO, HORNY_IP_BLOCK_LOGO } from '../../common/constants';


export default function Blocked() {
    const { settings } = useContext(MainContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (settings?.ipAllowed) {
            navigate(`/games`, { replace: true });
        }
    }, [ settings, navigate ]);

    return (
        <div
            className="blocked-container"
            style={{ background: `url(${ HORNY_BACKGROUND_LOGO })` }}
        >
            <img src={ HORNY_IP_BLOCK_LOGO } alt="Background with block icon" className="bg-image"/>
            <div className="block-text">
                Access to the site is restricted for users in your region.
                <br />
                We apologize for the inconvenience and thank you for your understanding.
            </div>
        </div>
    );
}